import { nanoid } from "nanoid";
import { createApi, createStore, guard } from "effector";
import { createGate } from "effector-react";

import type { Notification } from "./index.d";

export const $notificationsStore = createStore<Notification[]>([]);

const $hideFirst = $notificationsStore.map((store) => store.length > 5);

export const notifications = createApi($notificationsStore, {
  add: (store: Notification[], eventPayload: Notification) => {
    eventPayload.id = nanoid();
    return store.concat(eventPayload);
  },

  remove: (store, id: string) =>
    store.filter((notification) => notification.id !== id),
});

export const NotificationGate = createGate("notifies");

const $firstId = $notificationsStore.map((store, lastId) => {
  const { id = lastId } = store[0] || {};
  return id;
});

guard({
  source: $firstId,
  filter: $hideFirst,
  target: notifications.remove,
});
